import React from "react";
import styles from "./ListCardItem.module.scss";
import classNames from "classnames";
import Button from "../Button/Button";
import Dropdown from "../Dropdown/Dropdown";
import UploadFile from "../UploadFile/UploadFile";
import {TiposArchivoPermitidos} from "../../../util/Constants";

export interface ListCardItemProps {
  title: string;
  id: string;
  subtitle?: string;
  success?: boolean;
  button?: boolean;
  buttonProps?: ListCardItemButtonProps;
  buttonOp?: boolean;
  buttonOpProps?: ListCardItemButtonOpProps;
  observaciones?: string;
  fechaCarga?: string;
  onUploadCancel?: React.EventHandler<any>;
}

export interface ListCardItemButtonProps {
  id: string;
  name: string;
  text: string;
  disabled?: boolean;
  loader?: boolean;
  OnClick?: React.MouseEventHandler<any>;
}

export interface ListCardItemButtonOpProps {
  id: string;
  name: string;
  text: string;
  disabled?: boolean;
  loader?: boolean;
  OnClick?: React.MouseEventHandler<any>;
}

const minWidth = 576;

class ListCardItem extends React.Component<ListCardItemProps, any> {

  constructor(props: any) {
    super(props);
    this.state = {
      width: window.innerWidth,
      showDropdown: false,
      fullWidth: false
    };
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  componentWillMount() {
    if (this.state.width <= minWidth) {
      this.setState({showDropdown: true});
    } else {
      this.setState({showDropdown: false});
    }
    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  updateDimensions() {
    this.setState({
      width: window.innerWidth
    });
    if (this.state.width <= minWidth) {
      this.setState({showDropdown: true});
    } else {
      this.setState({showDropdown: false});
    }
  }

  render() {

    let successStyle;
    if (this.props.success === true) {
      successStyle = styles.Success;
    }

    let template;
    if (this.props.buttonOp && this.state.showDropdown === false) {
      template = styles.TwoButtonsGrid;
    } else {
      template = styles.SingleButtonGrid;
    }

    return (
      <li className={classNames(styles.ListCardItem)} id={"LCI" + this.props.id}>
        <div className={classNames(successStyle, template)}>
          <p>
            <span id="title" className={styles.Title}>{this.props.title}</span>
          </p>
          {this.props.subtitle &&
            <div className={styles.SubtitleGrid}>
                <span id="subtitle" className={classNames(styles.Subtitle, styles.Visible)}
                      dangerouslySetInnerHTML={{__html: this.props.subtitle}}/>
            </div>
          }   

          {(this.props.button && this.props.buttonOp && this.state.showDropdown === false) &&
          <>
            <div className={styles.ButtonGrid}>

              {this.props.buttonOpProps &&
              <Button id={this.props.buttonOpProps.id}
                      onClick={this.props.buttonOpProps.OnClick}
                      type="button"
                      typeStyle="ghost"
                      name={this.props.buttonOpProps.id}>
                {this.props.buttonOpProps.text}
              </Button>
              }
            </div>
            <div className={styles.ButtonOpGrid}>
              {this.props.buttonProps &&
              <UploadFile id={this.props.buttonProps.id}
                          buttonText={this.props.buttonProps.text}
                          documentTitle={this.props.title}
                          allowedMimeTypes={TiposArchivoPermitidos}
                          maxSizeInMB={8}
                          onCancel={this.props.onUploadCancel}
                          buttonNoFullWidth={false}
                          buttonTypeStyle={"ghost"}/>
              }
            </div>
          </>}

          {(this.props.button && !this.props.buttonOp && this.props.buttonProps) &&
          <>
            <div className={styles.ButtonGrid}>
              {this.props.buttonProps &&
              <UploadFile id={this.props.buttonProps.id}
                          buttonText={this.props.buttonProps.text}
                          documentTitle={this.props.title}
                          allowedMimeTypes={TiposArchivoPermitidos}
                          maxSizeInMB={8}
                          onCancel={this.props.onUploadCancel}
                          buttonNoFullWidth={false}
                          buttonTypeStyle={"ghost"}/>
              }
            </div>
          </>}

          {(this.state.showDropdown && this.props.buttonOp && this.props.button) &&
          <div className={classNames(styles.DropdownGrid)}>
            <Dropdown selectType="card">
              {this.props.buttonOpProps &&
              <Button id={this.props.buttonOpProps.id}
                      onClick={this.props.buttonOpProps.OnClick}
                      type="button"
                      typeStyle="secondary"
                      name={this.props.buttonOpProps.id}>
                {this.props.buttonOpProps.text}
              </Button>}
              {this.props.buttonProps &&
              <UploadFile id={this.props.buttonProps.id}
                          buttonText={this.props.buttonProps.text}
                          documentTitle={this.props.title}
                          allowedMimeTypes={TiposArchivoPermitidos}
                          maxSizeInMB={8}
                          onCancel={this.props.onUploadCancel}
                          buttonNoFullWidth={false}
                          buttonTypeStyle={"secondary"}/>}
            </Dropdown>
          </div>
          }
        </div>
      </li>
    );
  }
}

export default ListCardItem;
